// Parsec Cloud (https://parsec.cloud) Copyright (c) AGPL-3.0-only 2016-present Scille SAS

import FileEditor from '@/views/files/handler/editor/FileEditor.vue';

export * from '@/views/files/handler/editor/types';
export { FileEditor };
